import { HttpContextToken, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentLoaderService } from 'ok-angular-shared/services';
import { toCamelCase } from 'ok-angular-shared/utils';
import { map } from 'rxjs/operators';
import { AppSettings } from 'src/settings/appsettings.interface';

/**
 * Opts a request out of the response key conversion. Use it for endpoints whose responses contain
 * free-form dictionaries (e.g. push template custom data), where `toCamelCase` would rewrite
 * user-defined keys such as `Lpr_content` to `LprContent`.
 */
export const SKIP_CAMEL_CASE_CONVERSION = new HttpContextToken<boolean>(() => false);

export const snakeCaseInterceptor: HttpInterceptorFn = (req, next) => {
  const environmentLoaderService = inject<EnvironmentLoaderService<AppSettings>>(EnvironmentLoaderService);
  const baseUrl = environmentLoaderService.config?.appService?.baseUrl;

  if (baseUrl && req.url.includes(baseUrl) && !req.context.get(SKIP_CAMEL_CASE_CONVERSION)) {
    return next(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body && req.responseType !== 'blob') {
          return event.clone({ body: toCamelCase(event.body) });
        }
        return event;
      })
    );
  }

  return next(req);
};
